import enUSMessages from './locales/en-US.json';
import deDEMessages from './locales/de-DE.json';
import esESMessages from './locales/es-ES.json';
import frCAMessages from './locales/fr-CA.json';
import frFRMessages from './locales/fr-FR.json';
import itITMessages from './locales/it-IT.json';
import jaJPMessages from './locales/ja-JP.json';
import ptBRMessages from './locales/pt-BR.json';
import ruRUMessages from './locales/ru-RU.json';
import zhCNMessages from './locales/zh-CN.json';

export const messages = {
  'en-US': enUSMessages,
  'de-DE': deDEMessages,
  'es-ES': esESMessages,
  'fr-CA': frCAMessages,
  'fr-FR': frFRMessages,
  'it-IT': itITMessages,
  'ja-JP': jaJPMessages,
  'pt-BR': ptBRMessages,
  'ru-RU': ruRUMessages,
  'zh-CN': zhCNMessages,
};
